import { Icon } from '@/elements/icon/icon.component';
import { Container } from './button.elements';

import {
  IconArrowNarrowRight,
  IconChevronDown,
  IconChevronUp,
  IconTrash,
} from '@tabler/icons-react';

import { colors } from '@/styles/theme';

const Button = ({
  ref,
  onClick,
  disabled,
  style,
  children,
  color,
  naked,
  icon,
  filled,
  outline,
  width,
  background,
  justify,
  justifySelf,
  alignSelf,
  type,
}) => {
  const icons = {
    arrow: <IconArrowNarrowRight />,
    'chevron-up': <IconChevronUp size={20} />,
    'chevron-down': <IconChevronDown size={20} />,
    trash: <IconTrash size={20} color={colors.red} />,
  };

  return (
    <Container
      ref={ref}
      type={type}
      onClick={onClick}
      disabled={disabled}
      style={style}
      $color={color}
      $filled={filled}
      $naked={naked}
      $outline={outline}
      $width={width}
      $background={background}
      $justify={justify}
      $justifySelf={justifySelf}
      $alignSelf={alignSelf}
    >
      {children}
      {icon && <Icon>{icons[icon]}</Icon>}
    </Container>
  );
};

export { Button };
